import React from 'react';
import { isNil } from 'lodash';
import { Slide, Container, styled } from '@mui/material';
import { ACL_RESOURCE_TYPE_PROJECTS } from 'js/constants/aclConstants';
import ProjectOverviewContainer from './ProjectOverviewContainer';
import AclTabViewContainer from '../../elements/aclView/AclTabViewContainer';
import CardDetailView from '../../elements/cards/CardDetailView';
import { CARD_TYPE_PROJECT } from 'js/constants/cardTypes';
import StyledFixedPanel from 'new/components/StyledFixedPanel';
import { ProjectDetailHeader } from './ProjectDetailHeader';

class ProjectDetailView extends React.Component {
  constructor(props) {
    super(props);
    this._getSelectedCardTabs = this._getSelectedCardTabs.bind(this);
    this._getSelectedCardHeader = this._getSelectedCardHeader.bind(this);
    this._handleCloseDetailClicked = this._handleCloseDetailClicked.bind(this);
  }

  render() {
    const { project, type } = this.props;
    const open = !isNil(project);
    return (
      <>
        {project && (
          <div>
            <div className="modal-fader" onClick={(e) => this._handleCloseDetailClicked(e)} />
            <StyledFixedPanel>
              <CardDetailView
                data={project}
                tabs={this._getSelectedCardTabs()}
                preSelectedTab={type}
                detailHeaderContent={this._getSelectedCardHeader()}
                getSourceMeta={null}
                noHeaderPadding
              />
            </StyledFixedPanel>
          </div>
        )}
      </>
    );
  }

  _handleCloseDetailClicked(e) {
    this.props.onClose(e, this.props.id, this.props.type);
  }

  _getSelectedCardTabs() {
    return [
      {
        tabName: 'Overview',
        tabElement: <ProjectOverviewContainer />,
      },
      {
        tabName: 'Access',
        tabElement: <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_PROJECTS} />,
      },
    ];
  }

  _getSelectedCardHeader() {
    return <ProjectDetailHeader {...this.props} onCloseDrawer={this._handleCloseDetailClicked} />;
  }
}

export default ProjectDetailView;
